import { Components, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * MuiMultiSectionDigitalClock to make it match the design system.
 *
 * See: https://mui.com/x/api/date-pickers/multi-section-digital-clock/#css
 */

export const MuiMultiSectionDigitalClock: Components<Theme>['MuiMultiSectionDigitalClock'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '.Mui-selected': {
        background: theme.palette.designSystem.green[50],
        '&:hover': {
          background: theme.palette.designSystem.green[150],
        },
      },
    }),
  },
};
